// components/MenuList/index.jsx
import { useMemo } from 'react';
import { Typography } from '@mui/material';
import NavGroup from './NavGroup';
import pages from 'menuItems/pages';
import { useCan } from 'hooks/useCan';

const getMenuItems = () => {
    // if you later add multiple groups by role, keep this; else return [pages] directly
    return [pages];
};

// recursively filter by can()
const filterByPermissions = (node, can) => {
    if (!node) return null;

    if (node.type === 'group') {
        const children = (node.children || [])
            .map((child) => filterByPermissions(child, can))
            .filter(Boolean);

        if (children.length === 0) return null;
        return { ...node, children };
    }

    if (node.type === 'collapse') {
        const children = (node.children || [])
            .map((child) => filterByPermissions(child, can))
            .filter(Boolean);

        if (children.length === 0) return null;
        return { ...node, children };
    }

    if (node.type === 'item') {
        // no perm means public
        if (!node.perm) return node;
        const action = node.action || 'read';
        return can(node.perm, action) ? node : null;
    }

    return null;
};

const MenuList = ({ open }) => {
    const { can } = useCan();

    const menuItems = useMemo(() => getMenuItems(), []);
    const filtered = useMemo(
        () => menuItems.map((m) => filterByPermissions(m, can)).filter(Boolean),
        [menuItems, can]
    );

    const navItems = filtered.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} open={open} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;